"use strict";
// TODO: fix label prop to be proper type for Styled.Label and remove
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Box_1 = __importDefault(require("src/components/Box"));
var StyledDropdown_1 = __importDefault(require("./StyledDropdown"));
var icons_1 = require("../Icons/icons");
var Dropdown = function (_a) {
    var placeholder = _a.placeholder, label = _a.label, noResultsText = _a.noResultsText, selected = _a.selected, options = _a.options, searchable = _a.searchable, disabled = _a.disabled, a11yTitle = _a.a11yTitle, onClick = _a.onClick;
    var _b = (0, react_1.useState)(false), isOpen = _b[0], setIsOpen = _b[1];
    var _c = (0, react_1.useState)(options), filtered = _c[0], setFiltered = _c[1];
    var ref = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        var handleClickOutside = function (e) {
            if (!ref.current.contains(e.target)) {
                setIsOpen(false);
                setFiltered(options);
            }
        };
        document.addEventListener('click', handleClickOutside, true);
        return function () {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);
    var onChange = function (e) {
        setFiltered(options.filter(function (option) {
            var postName = option.label.toLowerCase();
            return postName.includes(e.target.value);
        }));
    };
    var handleCllck = function (currentValue) { return function () {
        setIsOpen(false);
        setFiltered(options);
        onClick(currentValue);
    }; };
    var handleOpen = function () {
        if (disabled) {
            return;
        }
        setIsOpen(!isOpen);
    };
    var Results = function (_a) {
        var children = _a.children;
        return (filtered.length > 0 ?
            children : react_1.default.createElement(StyledDropdown_1.default.OptionsButton, null, noResultsText || 'No results found'));
    };
    var selectedOptionColor = !selected ? { light: 'gray600', dark: 'grayBlue500' } : null;
    return (react_1.default.createElement(StyledDropdown_1.default.Container, { disabled: disabled, gap: 1, column: true, ref: ref, "aria-label": a11yTitle },
        label && react_1.default.createElement(StyledDropdown_1.default.Label, { disabled: disabled }, label),
        react_1.default.createElement(StyledDropdown_1.default.SelectContainer, null,
            !isOpen ? (react_1.default.createElement(StyledDropdown_1.default.Button, { disabled: disabled, color: selectedOptionColor, onClick: handleOpen }, selected || placeholder)) : (react_1.default.createElement(Box_1.default, { width: "100%" }, searchable ? (react_1.default.createElement(StyledDropdown_1.default.Input, { disabled: disabled, type: "text", autoFocus: true, placeholder: selected || placeholder, onChange: onChange })) : (react_1.default.createElement(StyledDropdown_1.default.Button, { disabled: disabled, color: selectedOptionColor, onClick: handleOpen }, selected || placeholder)))),
            react_1.default.createElement(StyledDropdown_1.default.IconBox, { disabled: disabled, isOpen: isOpen },
                react_1.default.createElement(icons_1.Down8, { size: "8", onClick: handleOpen, color: { light: 'gray600', dark: 'grayBlue500' } }))),
        isOpen && (react_1.default.createElement(StyledDropdown_1.default.Options, { column: true },
            react_1.default.createElement(Results, null, filtered.map(function (option) { return (react_1.default.createElement(StyledDropdown_1.default.OptionsButton, { key: option.label, active: selected === option.label, strong: selected === option.label, onClick: handleCllck(option.label) }, option.label)); }))))));
};
exports.default = Dropdown;
